import { useToast } from "@chakra-ui/react";
import React from "react";
import { useGetDocumentMutation } from "redux/services/documentRepository";
import { useGetProfileQuery } from "redux/services/membership";
import {
  getOrganisationMembership,
  renderContentTypeAsExtensionFile,
} from "utils";

const useDownloadFile = () => {
  const toast = useToast();

  const [downloadFile] = useGetDocumentMutation();
  const { data: ProfileData } = useGetProfileQuery();
  const membershipOrganisation = getOrganisationMembership(
    ProfileData?.data?.memberships
  );

  const orgToken = membershipOrganisation?.token;

  const handleDownloadFile = async (documentId: string) => {
    try {
      const file = await downloadFile({
        orgToken,
        documentId,
      }).unwrap();

      if (renderContentTypeAsExtensionFile(file?.data?.name)) {
        const bs64file = file?.data?.content;
        const linkSource = `data:${renderContentTypeAsExtensionFile(
          file?.data?.name
        )};base64,${bs64file}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = file?.data?.name;
        downloadLink.click();
        downloadLink.remove();
      } else {
        toast({
          title: "The file extension is not supported",
          description: "",
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
      }
    } catch (error: any) {
      toast({
        title: error?.data?.message ?? "Something went wrong",
        description: "",
        status: "error",
        duration: 9000,
        position: "top-right",
        isClosable: true,
      });
    }
  };

  return {
    handleDownloadFile,
  };
};

export default useDownloadFile;
